module.exports = __webpack_public_path__ + "img/15_15.068891d5.png";